export const translations = {
  ru_RU: {
    AUTO_LOGOUT: {
      DIALOG_HEADING_TEXT: "Вы неактивны продолжительное время",
      DIALOG_DESCRIPTION_TEXT:
        "В целях безопасности вашего аккаунта, через некоторое время произойдет автоматический выход из интернет-банка.",
      DIALOG_LOGOUT_BUTTON_TEXT: "Выйти из интернет-банка",
      DIALOG_CANCEL_LOGOUT_BUTTON_TEXT: "Продолжить работу",
    },
    LOGOUT: {
      END_SESSION_TEXT: "Ваш сеанс завершён.",
      FOR_CONTINUE_TEXT: "Для продолжения работы необходимо авторизоваться",
      NO_PERMISSIONS_TEXT:
        "Действующих полномочий не найдено. Свяжитесь с\u00A0руководителем вашей организации. Он может восстановить доступ через\u00A0отделение банка",
      HINT_TEXT: "Мы перенаправим вас автоматически на страницу входа через",
      CLOSE: "Закрыть",
      SECONDS: "секунд",
    },
  },
  en: {
    AUTO_LOGOUT: {
      DIALOG_HEADING_TEXT: "You have been inactive for a long time",
      DIALOG_DESCRIPTION_TEXT:
        "For the security of your account, you will be automatically logged out of online banking after some time.",
      DIALOG_LOGOUT_BUTTON_TEXT: "Log out of online banking",
      DIALOG_CANCEL_LOGOUT_BUTTON_TEXT: "Continue working",
    },
    LOGOUT: {
      END_SESSION_TEXT: "Your session has ended.",
      FOR_CONTINUE_TEXT: "To continue working, you need to log in",
      NO_PERMISSIONS_TEXT:
        "No active permissions found. Contact the head of your organization. He can restore access through the bank branch",
      HINT_TEXT: "We will automatically redirect you to the login page in",
      CLOSE: "Close",
      SECONDS: "seconds",
    },
  },
} as const;
